import type ThemeService from '@efdigital/ll-xceed-v2/services/theme';
import type ApplicationInstance from '@ember/application/instance';

/**
 * Apply the saved (or system) colour theme before the app first renders, so
 * there's no flash of the wrong theme on load.
 */
export function initialize(appInstance: ApplicationInstance): void {
  const theme = appInstance.lookup('service:theme') as ThemeService;
  theme.setup();
}

export default { initialize };
